<template>
    <div>
        <v-dialog persistent v-model="showProviderModal" scrollable :max-width="Global.MODAL_WIDTH" @close="close">
            <v-card>
                <v-card-title class="mb-0, pb-0">
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text class="mx-0, px-0">
                    <!--TABS-->
                    <v-tabs
                        v-model="active_tab"
                        color="blue-grey darken-2 white--text"
                        dark
                        slider-color="blue-grey darken-1"
                        grow
                    >
                        <!--Tab General-->
                        <v-tab :key="'tab_general'" ripple >Geral</v-tab>
                        <v-tab-item :key="'tab_general'" >
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field v-model="formProvider.name"
                                            :counter="$v.formProvider.name.$params.maxLength.max"
                                            :error-messages="nameErrors"
                                            @blur="$v.formProvider.name.$touch()"
                                            :disabled="providerShow"
                                            label="Nome*"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field type="number" v-model="formProvider.nif"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="nifErrors"
                                            @blur="$v.formProvider.nif.$touch()"
                                            :disabled="providerShow"
                                            label="Nif*"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-select v-model="formProvider.types_company_type_id"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="companyTypeErrors"
                                            @blur="$v.formProvider.types_company_type_id.$touch()"
                                            :disabled="providerShow"
                                            :items="companyTypes" label="Tipo Empresa*"></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-select v-model="formProvider.cities_id"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="cityErrors"
                                            @blur="$v.formProvider.cities_id.$touch()"
                                            :disabled="providerShow"
                                            :items="cities" label="Cidade*"></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-select v-model="formProvider.active_state"
                                            :color="formProvider.active_state ? 'green' : 'red'"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="activeStateErrors"
                                            @blur="$v.formProvider.active_state.$touch()"
                                            :disabled="providerShow"
                                            :items="active_states" label="Estado*"></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field v-model="formProvider.address"
                                            :counter="$v.formProvider.address.$params.maxLength.max"
                                            :error-messages="addressErrors"
                                            @blur="$v.formProvider.address.$touch()"
                                            :disabled="providerShow"
                                            label="Endereço"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field type="number"
                                            v-model="formProvider.postal_code"
                                            :counter="$v.formProvider.description.$params.maxLength.max"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="postalCodeErrors"
                                            @blur="$v.formProvider.postal_code.$touch()"
                                            :disabled="providerShow"
                                            label="Código postal"></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-combobox
                                            v-model.number="formProvider.category"
                                            :items="categories"
                                            item-text="name"
                                            item-value="id"
                                            :disabled="providerShow"
                                            :small-chips="!!formProvider.category && !!formProvider.category.id"
                                            label="Categoria"
                                        ></v-combobox>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-combobox
                                            v-model="formProvider.subcategory"
                                            :items="subcategories"
                                            item-text="name"
                                            item-value="id"
                                            :disabled="providerShow"
                                            :small-chips="!!formProvider.subcategory && !!formProvider.subcategory.id"
                                            label="Subcategoria"
                                        ></v-combobox>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field v-model="formProvider.website"
                                            :counter="$v.formProvider.website.$params.maxLength.max"
                                            :error-messages="websiteErrors"
                                            @blur="$v.formProvider.website.$touch()"
                                            :disabled="providerShow"
                                            label="Website"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 px-2>
                                        <v-textarea v-model="formProvider.description"
                                            :counter="$v.formProvider.description.$params.maxLength.max"
                                            :error-messages="descriptionErrors"
                                            @blur="$v.formProvider.description.$touch()"
                                            solo
                                            :disabled="providerShow"
                                            label="Descrição" ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>

                        <!--Tab Contact-->
                        <v-tab :key="'tab_contact'" ripple >Contacto</v-tab>
                        <v-tab-item :key="'tab_contact'" >
                            <!--<v-card flat>-->
                            <v-container>
                                <v-text-field
                                    v-model="newContactName"
                                    append-outer-icon="done"
                                    @click:append-outer="visuallyAddContact"
                                    @keyup.enter="visuallyAddContact"
                                    label="Novo Contacto"
                                    v-if="!providerShow"></v-text-field>

                                <!--Expandable components (Contact list)-->
                                <v-expansion-panel popout :value="formProvider.contacts_json.length === 1 ? 0 :1">
                                    <p v-if="active_tab===1 && formProvider.contacts_json.length <= 0">nenhum contacto adicionado ainda</p>
                                    <v-expansion-panel-content
                                        v-for="(contact, index) in formProvider.contacts_json"
                                        :key="index"
                                        :class="index%2 === 1? 'grey lighten-2' : 'grey lighten-3'"
                                    >
                                        <div slot="header"><b>{{contact.name}}</b> <span v-if="contact.role"> - {{contact.role}}</span></div>

                                        <div style="padding: 10px; background: white" >
                                            <v-layout wrap>
                                                <v-flex xs12 sm6 px-2>
                                                    <v-text-field
                                                        v-model="contact.role"
                                                        label="Descrição"
                                                        :readonly="providerShow"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 px-2>
                                                    <v-text-field
                                                        v-model="contact.email"
                                                        label="Email"
                                                        :readonly="providerShow"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 px-2>
                                                    <v-text-field
                                                        v-model="contact.phone"
                                                        label="Móvel"
                                                        prefix="(+238)"
                                                        mask="### ## ##"
                                                        :readonly="providerShow"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 px-2>
                                                    <v-text-field
                                                        v-model="contact.mobile_phone"
                                                        prefix="(+238)"
                                                        label="Fixo"
                                                        mask="### ## ##"
                                                        :readonly="providerShow"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 v-if="!providerShow && index > 0">
                                                    <v-hover>
                                                        <v-btn
                                                            slot-scope="{ hover }"
                                                            :class="'{hover ?  : red}'"
                                                            small flat icon color="grey" @click="visuallyRemoveContact(index)">
                                                            <v-icon>delete</v-icon>
                                                        </v-btn>
                                                    </v-hover>
                                                </v-flex>

                                            </v-layout>
                                        </div>

                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-container>
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn depressed @click="close">Cancelar</v-btn>
                        <v-btn v-if="!providerShow && active_tab === 0" :disabled="$v.$invalid" color="primary" @click="active_tab = 1">Seguinte</v-btn>
                        <v-btn v-if="!providerShow && active_tab !== 0" :disabled="$v.$invalid" color="primary" @click="save">Guardar</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    /* eslint-disable */
    import Vue from 'vue';
    import {eventBus} from "../../main";
    import {mapActions, mapGetters} from 'vuex'
    import {Model, Global} from "../../config";
    import {maxLength, minLength, minValue, required} from 'vuelidate/lib/validators';
    import _ from 'lodash';
    export default {
        name: "FormModal",

        beforeDestroy(){
            eventBus.$off('onProviderModalOpen');
        },

        data () {
            return {
                Global,
                newContactName: '',
                active_tab: 0,
                loading_modal: false,
                companies: [], //list of companeis used in auto complete field (this is querried at the moment)

                //company form modal needed attributes
                company_types: [],
                company_categories: [],
                // cities: [],

                //AutoComplete
                isLoading: false,
            }
        },



        props: {
            active_states: Array,
            cities: Array,
            companyTypes: Array,
            categories: Array,
            subcategories: Array,
        },

        validations: {
            formProvider: {
                name: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(100),
                },
                nif: {
                    required,
                    minValue: minValue(0),
                },
                types_company_type_id: {
                    required,
                },
                cities_id: {
                    required,
                },
                address: {
                    maxLength: maxLength(250),
                },
                postal_code: {
                    maxLength: maxLength(100),
                },
                active_state: {
                    required,
                },
                website: {
                    maxLength: maxLength(100),
                },
                description: {
                    maxLength: maxLength(250),
                }
            }

        },

        components: {

        },

        watch: {
            showProviderModal(){
                if(this.showProviderModal){
                    this.onProviderFormOpened();
                }
            },

        },

        computed: {
            ...mapGetters([
                'loggedUser',
                'isLoggedUserSuperAdmin'
            ]),
            showProviderModal: {
                get(){
                    return this.$store.getters.getShowProviderModal;
                },
                set(value){
                    this.$store.dispatch('setShowProviderModal', value);
                }
            },
            selectedProvider: {
                get(){
                    return this.$store.getters.getSelectedProvider;
                },
                set(value){
                    this.$store.dispatch('setSelectedProvider', value);
                }
            },

            formProvider: {
                get(){
                    let formProviderr = this.$store.getters.getFormProvider;
                    formProviderr.contacts_json = Array.from(this.getContactsJson(formProviderr));
                    return formProviderr;
                },
                set(value){
                    this.$store.dispatch('setFormProvider', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            providerShow: {
                get(){
                    return this.$store.getters.getProviderShow;
                },
                set(value){
                    this.$store.dispatch('setProviderShow', value);
                }
            },

            formTitle () {
                return this.providerShow ? 'Fornecedor' : (this.selectedProvider.id ? 'Editar Fornecedor' : 'Novo Fornecedor');
            },
            nameErrors () {
                const errors = [];
                if (!this.$v.formProvider.name.$dirty) return errors;
                // !this.$v.formProvider.name.decimal && errors.push('Name must be a number')
                !this.$v.formProvider.name.minLength && errors.push('Mínimo de 2 caracteres');
                !this.$v.formProvider.name.maxLength && errors.push('Máximo de 30 caracteres');
                !this.$v.formProvider.name.required && errors.push('Digite um nome');
                return errors
            },
            nifErrors () {
                const errors = [];
                if (!this.$v.formProvider.nif.$dirty) return errors;
                !this.$v.formProvider.nif.minValue && errors.push('Introduza valores não negativos');
                !this.$v.formProvider.nif.required && errors.push('Introduza nif');
                return errors
            },
            companyTypeErrors() {
                const errors = [];
                if (!this.$v.formProvider.types_company_type_id.$dirty) return errors;
                !this.$v.formProvider.types_company_type_id.required && errors.push('Escolha um tipo de empresa');
                return errors
            },
            cityErrors () {
                const errors = [];
                if (!this.$v.formProvider.cities_id.$dirty) return errors;
                !this.$v.formProvider.cities_id.required && errors.push('Escolha uma cidade.');
                return errors
            },
            addressErrors () {
                const errors = [];
                if (!this.$v.formProvider.address.$dirty) return errors;
                // !this.$v.formProvider.name.decimal && errors.push('Name must be a number')
                !this.$v.formProvider.address.maxLength && errors.push('Maximo de 120 caracteres.');
                return errors
            },
            postalCodeErrors () {
                const errors = [];
                if (!this.$v.formProvider.postal_code.$dirty) return errors;
                // !this.$v.formProvider.name.decimal && errors.push('Name must be a number')
                !this.$v.formProvider.postal_code.maxLength && errors.push('Maximo de 30 caracteres.');
                return errors
            },
            activeStateErrors () {
                const errors = [];
                if (!this.$v.formProvider.active_state.$dirty) return errors;
                !this.$v.formProvider.active_state.required && errors.push('Escolha um estado');
                return errors
            },
            websiteErrors () {
                const errors = [];
                if (!this.$v.formProvider.website.$dirty) return errors;
                !this.$v.formProvider.website.maxLength && errors.push('Maximo de 60 caracteres.');
                return errors
            },
            descriptionErrors () {
                const errors = [];
                if (!this.$v.formProvider.description.$dirty) return errors;
                // !this.$v.formProvider.name.decimal && errors.push('Name must be a number')
                !this.$v.formProvider.description.maxLength && errors.push('Maximo de 250 caracteres.');
                return errors
            },
        },

        methods: {
            ...mapActions([
                'setShowCompanyModal'
            ]),

            showSnackBar(message, color){
                this.snackbar = true;
                this.text = message;
                this.snackbar_color = color;
            },

            getContactsJson(item){
                if(!item.contacts_json) {
                    return [];
                }
                if(item.contacts_json instanceof Array){
                    return item.contacts_json;
                } else{
                    return JSON.parse(item.contacts_json);
                }
            },

            addProvider(){
                try{
                    this.loading_modal = true;
                    Vue.axios.post('provider', {
                        name: this.formProvider.name,
                        nif: this.formProvider.nif,
                        types_company_type_id: this.formProvider.types_company_type_id,
                        cities_id: this.formProvider.cities_id,
                        address: this.formProvider.address,
                        postal_code: this.formProvider.postal_code,
                        active_state: this.formProvider.active_state,
                        website: this.formProvider.website,
                        contacts_json: this.formProvider.contacts_json,
                        description: this.formProvider.description,

                        category_id: this.formProvider.category && this.formProvider.category.id ? this.formProvider.category.id : '',
                        category_name: this.formProvider.category ? this.formProvider.category.name ? this.formProvider.category.name : this.formProvider.category : '',
                        model: Model.PROVIDER,

                        subcategory_id: this.formProvider.subcategory && this.formProvider.subcategory.id ? this.formProvider.subcategory.id : '',
                        subcategory_name: this.formProvider.subcategory ? this.formProvider.subcategory.name ? this.formProvider.subcategory.name : this.formProvider.subcategory : '',
                        subcategory_model: Model.PROVIDER,
                    })
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            // this.consoleLog(response);
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.$emit('onFormProviderDone');
                        this.close();
                        this.showSnackBar('Fornecedor adicionado com sucesso', 'success');

                        // this.loading_modal = false;
                        // this.formProvider = this.getNewCompany();
                        // this.$v.$reset();
                        // this.active_tab = 0;
                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao adicionar fornecedor', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao adicionar fornecedor!', 'error');
                    this.loading_modal = false;
                }
            },

            updateProvider(){
                try{
                    if(this.selectedProvider === null) {
                        this.showSnackBar('Ocorreu um erro ao atualizar fornecedor', 'error');
                        return;
                    }

                    this.loading_modal = true;
                    Vue.axios.put('provider/'+this.selectedProvider.id, {
                        name: this.formProvider.name,
                        nif: this.formProvider.nif,
                        types_company_type_id: this.formProvider.types_company_type_id,
                        cities_id: this.formProvider.cities_id,
                        address: this.formProvider.address,
                        postal_code: this.formProvider.postal_code,
                        active_state: this.formProvider.active_state,
                        website: this.formProvider.website,
                        contacts_json: this.formProvider.contacts_json,
                        description: this.formProvider.description,

                        category_id: this.formProvider.category && this.formProvider.category.id ? this.formProvider.category.id : '',
                        category_name: this.formProvider.category ? this.formProvider.category.name ? this.formProvider.category.name : this.formProvider.category : '',
                        model: Model.PROVIDER,

                        subcategory_id: this.formProvider.subcategory && this.formProvider.subcategory.id ? this.formProvider.subcategory.id : '',
                        subcategory_name: this.formProvider.subcategory ? this.formProvider.subcategory.name ? this.formProvider.subcategory.name : this.formProvider.subcategory : '',
                        subcategory_model: Model.PROVIDER,

                    }).then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.showSnackBar('Erro ao atualizar fornecedor', 'error');
                            return;
                        }
                        this.setUpCategoryAndSubcategory(this);
                        this.$emit('onFormProviderDone');
                        this.close();
                        this.showSnackBar('Fornecedor atualizado com sucesso', 'success');

                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao atualizar fornecedor', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao atualizar fornecedor!', 'error');
                    this.loading_modal = false;
                }
            },

            resetForm(){
                this.formProvider.name = '';
                this.formProvider.nif = '';
                this.formProvider.cities_id = '';
                this.formProvider.address = '';
                this.formProvider.types_company_type_id = '';
                this.formProvider.postal_code = '';
                this.formProvider.active_state = '';
                this.formProvider.website = '';
                this.formProvider.description = '';
                this.formProvider.contacts_json = [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}];
            },

            close () {
                this.showProviderModal = false;
                this.newContactName = '';
                this.active_tab = 0;
                this.$v.$reset();
                this.resetForm();

                this.selectedProvider = null;
                this.loading = false;
                this.providerShow = false;
            },

            save () {
                setTimeout(()=>{
                    if (this.selectedProvider.id) {
                        this.updateProvider();
                    } else {
                        this.addProvider();
                    }
                }, 100);
            },

            visuallyAddContact(){
                if(this.newContactName === '') return;
                let contact = {

                    name: this.role ? this.newContactName+' - '+this.role : this.newContactName,
                    role: this.role,
                    email: this.email,
                    mobile_phone: this.mobile_phone,
                    phone: this.phone,
                };
                if(!this.formProvider.contacts_json){
                    this.formProvider.contacts_json = [];
                }
                this.formProvider.contacts_json.splice(1, 0, contact);
                this.newContactName = '';
            },

            visuallyRemoveContact(index){
                this.formProvider.contacts_json.splice(index, 1);
            },

            visuallyDeleteContactLine(contactLines, index2){
                contactLines.splice(index2, 1);
            },

            getNewEmptyContact(){
                return { phone: '', mobile_phone: '', email: '', fax: ''}
            },

            onProviderFormOpened(){
                this.setUpCategoryAndSubcategory(this);

                if(this.selectedProvider && !this.selectedProvider.id) {
                    this.consoleLog('form opened');
                    this.formProvider.active_state = 1;
                }
                if(!this.selectedProvider.id){
                    this.formProvider.contacts_json = [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}];
                }
            },

            setUpCategoryAndSubcategory(vm){
                if(!vm.categories) return;
                for(let i=0; i<vm.categories.length; i++){
                    // vm.consoleLog("category: "+vm.categories[i].id +'  |  '+vm.selectedClient.category_id);
                    if(vm.categories[i].id === vm.selectedProvider.category_id){
                        vm.formProvider.category = vm.categories[i];
                    }
                }
                if(!vm.subcategories) return;
                for(let i=0; i<vm.subcategories.length; i++){
                    // vm.consoleLog("subcategories: "+vm.subcategories[i].id +'  |  '+vm.selectedClient.subcategory_id);
                    if(vm.subcategories[i].id === vm.formProvider.subcategory){
                        vm.formProvider.subcategory = vm.subcategories[i];
                    }
                }
            },

        },

    }
</script>

<style scoped>

</style>